<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="serviceItems"
      class="elevation-1"
      :loading="isLoading"
    >
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-btn
            color="success"
            data-cy="ServiceItem-button-new"
            @click="$router.push({
              name: 'quotes-EditServiceItem'
            })"
          >
            <v-icon class="mr-2">
              {{ mdiPlus }}
            </v-icon>
            {{ $t('common.buttons.new') }}
          </v-btn>
          <div class="text-h5 ml-2">
            Services
          </div>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <TableBasicButtons :editLink="{
            name: 'quotes-EditServiceItem',
            query: {id: item.id}
          }"
          @delete="remove(item)"
        />
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListServiceItem',
  module: 'ServiceItem',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('serviceItems', ['serviceItems']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('serviceName'),
          value: 'serviceName',
        },
        {
          text: this.$$t('isp'),
          value: 'isp',
        },
        {
          text: this.$$t('serviceAddress'),
          value: 'serviceAddress',
        },
        {
          text: this.$$t('officeHours'),
          value: 'officeHours',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_serviceItems();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('serviceItems', ['LOAD_serviceItems', 'DELETE_serviceItem']),
    /** Delete ServiceItem from the collection
     */
    async remove(serviceItem) {
      this.isLoading = true;
      await this.DELETE_serviceItem(serviceItem.id);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# ServiceItem example

'''js
<ServiceItem />
'''
</docs>
